import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormGroup from '@material-ui/core/FormGroup';
import Hidden from '@material-ui/core/Hidden';

import { pages, } from 'styles';

const FormLabelWrapper: React.FC = ({ children }) => {
    const labelClasses = pages.products.makeCheckboxLabelStyles();

    // @ts-ignore
    return (<FormLabel component="legend" classes={labelClasses} focused={false}>{children}</FormLabel>);
};

type Props = {
    name: string;
    children: JSX.Element[];
};

const Choices: React.FC<Props> = ({ name, children, }) => {
    const formControlContainerClasses = pages.products.makeProductsContainerFilterStyles();

    return (
        <FormControl component="fieldset"
                     classes={formControlContainerClasses}
                     margin="normal">
            <Hidden smDown>
                <FormLabelWrapper>
                    {name}
                </FormLabelWrapper>
            </Hidden>
            <FormGroup>
                {children}
            </FormGroup>
        </FormControl>
    );
};

export default Choices;
